import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../services/auth";
// * custom components
import Header from "./Header";
import Sidebar from "./Sidebar";

const HomeLayout = () => {
  const { authData } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authData?.token) {
    } else {
      navigate("/");
    }
  }, [authData, navigate]);

  return (
    <div className="w-full h-full flex flex-row">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Header />
        <Outlet />
      </div>
    </div>
  );
};

export default HomeLayout;
